import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { EmailSettingsConstants as ui } from '../../Config/UIConstants';
import { EmailNotificationDigestType } from '../../Models/IUser';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { ExitableAlert } from '../../SharedComponents/ExitableAlert';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { Checkmark } from '../../images/images';
import { colors } from '../../styles/colors';
import { largeShadow } from '../../styles/styleObjects';

interface IProps {
    store?: ApplicationStore;
}

interface IState {
    setting?: EmailNotificationDigestType;
    showSaveConfirmation: boolean;
    originalSetting?: EmailNotificationDigestType;
}

@inject('store')
@observer
export class EmailSettingsTab extends React.Component<IProps, IState> {
    public state: IState = {
        setting: undefined,
        showSaveConfirmation: false,
        originalSetting: undefined,
    };

    private get store(): ApplicationStore {
        return this.props.store!;
    }

    private onPressSave = () => {
        this.setState({ showSaveConfirmation: true });
        this.store.userProfileStore.updateNotificationFrequency(this.state.setting!);
    }

    private renderSettingsCell(setting: EmailNotificationDigestType) {
        return (
            <div key={setting} style={styles.cellContainer} onClick={() => this.setState({ setting })}>
                <p style={styles.cellText}>{EmailNotificationDigestType[setting]}</p>
                {this.state.setting === setting ? <img style={styles.checkMark} src={Checkmark} /> : <div style={styles.checkMark} />}
            </div>
        );
    }

    public componentDidMount(): void {
        when(
            () => this.store.userProfileStore && this.store.userProfileStore.userIsLoaded,
            () => {
                const setting = this.store.userProfileStore.user.email_notification_digest_type_id;
                this.setState({ setting, originalSetting: setting === undefined ? EmailNotificationDigestType.Weekly : setting });

                if (setting === undefined) {
                    this.store.userProfileStore.updateNotificationFrequency(EmailNotificationDigestType.Weekly);
                    this.setState({ setting: EmailNotificationDigestType.Weekly, originalSetting: EmailNotificationDigestType.Weekly });
                }
            },
        );
    }

    public render() {
        if (this.state.setting === undefined) {
            return null;
        }

        return (
            <div style={styles.container}>
                <div style={styles.headerContainer}>
                    <p style={styles.headerText}>{ui.HEADER}</p>
                </div>
                <div style={styles.allCellsContainer}>
                    {this.renderSettingsCell(EmailNotificationDigestType.Daily)}
                    {this.renderSettingsCell(EmailNotificationDigestType.Weekly)}
                    {this.renderSettingsCell(EmailNotificationDigestType.None)}
                </div>

                <CommonActionButton
                    buttonContent={ui.SAVE}
                    onClick={this.onPressSave}
                    containerStyle={styles.saveMargin}
                    isDisabled={this.state.originalSetting === this.state.setting}
                />

                {this.state.showSaveConfirmation && (
                    <ExitableAlert confirmText={ui.OK} headerText={ui.EXIT_HEADER} onConfirmClick={() => this.setState({ showSaveConfirmation: false })} />
                )}
            </div>
        );
    }
}

const styles = {
    saveMargin: {
        marginTop: 100,
    },
    container: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
    } as React.CSSProperties,
    headerContainer: {
        height: 70,
        width: 400,
        backgroundColor: '#423F4E',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        marginTop: 25,
    } as React.CSSProperties,
    headerText: {
        color: 'white ',
    },
    checkMark: {
        width: 25,
        height: 25,
        borderRadius: 25,
        backgroundColor: colors.ACTION_BAR,
        objectFit: 'contain',
        padding: 5,
    } as React.CSSProperties,
    cellContainer: {
        height: 70,
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 30,
        paddingRight: 25,
        borderBottom: '1px solid #48A29B30',
        alignItems: 'center',
        cursor: 'pointer',
    } as React.CSSProperties,
    flex: {
        display: 'flex',
    },
    cellText: {
        color: '#423F4E',
        fontSize: 16,
    },
    allCellsContainer: {
        width: 400,
        boxShadow: largeShadow,
    },
};



// WEBPACK FOOTER //
// ./src/Pages/ProfileSettings/EmailSettingsTab.tsx